import { Injectable } from '@angular/core';
import { createPropertySelectors, State } from '@ngxs/store';
import { ClientIntakeForm } from '@models/client-intake';

export interface IntakeFormClientPortalStateModel {
	intakeForm: ClientIntakeForm | null;
}

const DEFAULT_STATE: IntakeFormClientPortalStateModel = {
	intakeForm: null,
};

@Injectable()
@State({
	name: 'intakeFormClientPortal',
	defaults: DEFAULT_STATE,
})
export class IntakeFormClientPortalState {
	static readonly _props =
		createPropertySelectors<IntakeFormClientPortalStateModel>(
			IntakeFormClientPortalState,
		);
}
